<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <v-card class="lighten-4 mr-3" dark color="rgba(29, 27, 65, 0.6)" style="height:100%;">
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="5"
      :options.sync="pagination"
      class="elevation-0 transparent"
      dark
      :footer-props="{
        itemsPerPageOptions: [5]
      }"
      v-show="countrySelected === false"
    >
      <template v-slot:item.position="{ item }">
        <div class="caption grey--text text--lighten-1" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">{{ item.position }}</div>
      </template>
      <template v-slot:item.country="{ item }">
        <div class="caption grey--text text--lighten-1" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">{{ item.country }}</div>
      </template>
      <template v-slot:item.confirmed="{ item }">
        <div class="caption blue--text text--lighten-2" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">{{ getNumberDisplay(item.confirmed) }}</div>
        <div v-if="item.confirmed_change != 0" class="caption pink--text text--lighten-3" style="font-size: 10px !important;">{{'+ ' + getNumberDisplay(item.confirmed_change)}}</div>
      </template>
      <!-- <template v-slot:item.recovered="{ item }">
        <div class="caption green--text text--lighten-1" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">{{ getNumberDisplay(item.recovered) }}</div>
      </template> -->
      <template v-slot:item.deaths="{ item }">
        <div class="caption pink--text text--lighten-2" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">{{ getNumberDisplay(item.deaths) }}</div>
      </template>
      <!-- <template v-slot:item.active="{ item }">
        <div class="caption orange--text text--lighten-2" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">{{ getNumberDisplay(item.active) }}</div>
      </template> -->
    </v-data-table>

    <!-- <v-row>
      <v-col cols="12" class="text-center">
        <div class="pa-5 pt-0">
          <div class="mb-3" style="font-weight: 300;">{{ 'Current Status for ' + countryDisplay }}</div>
          <apexchart type="bar" height="16" :options="chartOptions" :series="series"></apexchart>
        </div>
      </v-col>
    </v-row> -->

    <v-row v-show="countrySelected === true">
      <v-col cols="12" md="4" class="pa-0">
          <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
            <div><v-icon dark size="40" color="purple lighten-2">person</v-icon></div>
            <div class="headline mt-3">{{selectedCountryPop + 'M'}}</div>      
            <div class="caption grey--text text--lighten-2 mt-2">TOTAL POPULATION</div>
          </v-card>
      </v-col>
      <v-col cols="12" md="4" class="pa-0">
          <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
            <div><v-icon dark size="40" color="purple lighten-2">coronavirus</v-icon></div>
            <div class="headline mt-3">{{selectedCountryConfirmedPop}}</div>      
            <div class="caption grey--text text--lighten-2 mt-2">CONFIRMED PER 100k POPULATION</div>
          </v-card>
      </v-col>
      <v-col cols="12" md="4" class="pa-0">
          <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
            <div><v-icon dark size="40" color="purple lighten-2">error</v-icon></div>
            <div class="headline mt-3">{{selectedCountryDeathsPop}}</div>      
            <div class="caption grey--text text--lighten-2 mt-2">DEATHS PER 100k POPULATION</div>
          </v-card>
      </v-col>
    </v-row>
    <v-row v-show="countrySelected === true">
      <v-col cols="12" md="4" class="pa-0">
          <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
            <div><v-icon dark size="40" color="purple lighten-2">biotech</v-icon></div>
            <div class="headline mt-3">{{selectedCountryTests}}</div>      
            <div class="caption grey--text text--lighten-2 mt-2">TOTAL TESTS</div>
          </v-card>
      </v-col>
      <v-col cols="12" md="4" class="pa-0">
          <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
            <div><v-icon dark size="40" color="purple lighten-2">hotel</v-icon></div>
            <div class="headline mt-3">{{selectedCountryBedsPop}}</div>      
            <div class="caption grey--text text--lighten-2 mt-2">HOSPITAL BEDS PER 100k POPULATION</div>
          </v-card>
      </v-col>
      <v-col cols="12" md="4" class="pa-0" v-show="$vuetify.breakpoint.lgAndUp">
          <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
            <div><v-icon dark size="40" color="purple lighten-2">local_hospital</v-icon></div>
            <div class="headline mt-3">{{selectedCountryHospitals}}</div>      
            <div class="caption grey--text text--lighten-2 mt-2">PUBLIC HEALTH FACILITIES</div>
          </v-card>
      </v-col>
    </v-row>

  </v-card>
</template>

<script>

export default {
  name: "List",
  data: () => ({
    headers: [
      { text: '#', value: 'position' },
      { text: 'Country', value: 'country' },
      { text: 'Confirmed', value: 'confirmed' },
      // { text: 'Recovered', value: 'recovered' },
      { text: 'Deaths', value: 'deaths' },
      // { text: 'Active', value: 'active' }
    ],
    items: [],
    pagination: {
      page: 1
    },
    countrySelected: false,
    countryDisplay: '',
    selectedCountryPop: "",
    selectedCountryConfirmedPop: "",
    selectedCountryDeathsPop: "",
    selectedCountryBedsPop: "",
    selectedCountryHospitals: "",
    selectedCountryTests: "",
    series: [],
    chartOptions: {
        colors: ["#4CAF50", "#e91e63", "#ffa726"],
        chart: {
          background: "transparent",
          toolbar: {
            show: false
          },
          stacked: true,
          stackType: '100%',
           sparkline: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#fff'],
            fontSize: '10px',
            fontWeight: '100',
          },
          // offsetX: 0,
          //offsetY: 1,
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex].data[0]
          }
        },
        grid: {
           show: false
        },
        legend: {
          show: false
        },
        tooltip: {
          x: {
            show: true
          },
          theme: "dark"
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
          }
        },
        xaxis: {
          categories: [""],
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false
          }
        },
        yaxis: {
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false
          }
        }
      }
  }),
  methods: {
    loadCases(data, countryDisplay) {
      //clear data
      this.items = []
      this.series = []
      this.pagination.page = 1
      this.selectedCountryPop = ""
      this.selectedCountryConfirmedPop = ""
      this.selectedCountryDeathsPop = ""
      this.selectedCountryBedsPop = ""
      this.selectedCountryHospitals = ""
      this.selectedCountryTests = ""

      //check no data
      if (data.length === 0) {
        return;
      }

      if(countryDisplay && countryDisplay !== "") {
        this.countrySelected = true
        this.countryDisplay = countryDisplay
      }
      else {
        this.countrySelected = false
        this.countryDisplay = 'Africa'
      }

      //loop through each country and add to items
      var countries = []
      for (var i = 0; i < data.length; i++) {
        
        //first calculate the latest stats
        var lastConfirmed = data[i].cases[data[i].cases.length - 1].cumulative_cases
        //var prevConfirmed = data[i].cases[data[i].cases.length - 2].cumulative_cases
        var lastRecovered = data[i].cases[data[i].cases.length - 1].cumulative_recovered
        var lastDeaths = data[i].cases[data[i].cases.length - 1].cumulative_deaths
        var lastActive = lastConfirmed - lastRecovered - lastDeaths
        var confirmed_change =  data[i].cases[data[i].cases.length - 1].new_cases //lastConfirmed - prevConfirmed
        var population = data[i].population.population*1
        var beds = data[i].population.hospital_beds_100k
        
        var tests = 0  
        if(data[i].tests.length > 0) {
          tests = data[i].tests[data[i].tests.length -1]["Cumulative total"]*1 
        }

        countries.push({
          country: data[i].Country_WHO,
          confirmed: lastConfirmed,
          recovered: lastRecovered,
          deaths: lastDeaths,
          active: lastActive,
          confirmed_change: confirmed_change,
          population: population,
          beds: beds,
          tests: tests
        })
      }

      //sort by confirmed
      countries = countries.sort(function(a, b) {
        a = a.confirmed;
        b = b.confirmed;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //set the position for each country and add up the series data
      var totalRecovered = 0
      var totalDeaths = 0
      var totalActive = 0

      for (var i = 0; i < countries.length; i++) {
        countries[i].position = i + 1

        //add up the data
        totalRecovered += countries[i].recovered
        totalDeaths += countries[i].deaths
        totalActive += countries[i].active

      }

      //set items
      this.items = countries

      //set series
      this.series = [{name: "Recovered", data: [totalRecovered]}, {name: "Deaths", data: [totalDeaths]}, {name: "Active", data: [totalActive]}]

      //set the population data
      if(this.countrySelected === true) {

        //calc pop million
        var popCount = countries[0].population
        popCount = popCount/1000000
        popCount = parseFloat(popCount.toFixed(1))
        this.selectedCountryPop = popCount

        //calculate the latest confirmed and deaths per 100k population
        var latestconfirmed = countries[0].confirmed
        var latestdeaths = countries[0].deaths
        var totalpop = countries[0].population

        var confper100k = (latestconfirmed/totalpop) * 100000
        confper100k = parseFloat(confper100k.toFixed(0))
        this.selectedCountryConfirmedPop = confper100k

        var rdeathsper100k = (latestdeaths/totalpop) * 100000
        var deathsper100k = parseFloat(rdeathsper100k.toFixed(0))

        if(deathsper100k === 0) {
          deathsper100k = parseFloat(rdeathsper100k.toFixed(2))
        }
        
        this.selectedCountryDeathsPop = deathsper100k

        this.selectedCountryBedsPop = countries[0].beds

        this.selectedCountryTests = countries[0].tests

        //get the hospitals from the map
        this.$emit("getHospitals", this.countryDisplay)

      }

      var self = this
      setTimeout(function() {
        self.$emit("resize")
      }, 5000)    

    },
    getNumberDisplay(number) {
      return number.toLocaleString("en").replace(/\,/g, " ");
    },
    setHospitals(hospitals) {
      this.selectedCountryHospitals = hospitals.length
    }
  },
};
</script>

<style>
.theme--dark.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background:rgba(0, 0, 0, 0.2) !important;
}
</style>